export default __webpack_public_path__ + "static/media/map-image.009ab370.png";